import { InputNumber } from 'antd';
import styled from 'styled-components';

export const StyledInput = styled(InputNumber)`
  width: 70px;
  margin-right: 8px;
`;

export const StyledUnit = styled.div`
  padding-top: 5px;
`;

export const StyledConfigLabel = styled.div`
  color: #777;
  padding: 0 0 5px;
  font-weight: 500;
  font-size: 14;
  display: flex;
`;

export const StyledInputWrapper = styled.div`
  padding: 0 0 8px;
  font-weight: 500;
  font-size: 14;
  display: flex;
`;
